export const BASE_URL = "https://tin.onrender.com/"
